// extracted by mini-css-extract-plugin
export default {"marqueeContainer":"NewsTicker_marqueeContainer__8vxwu","marquee":"NewsTicker_marquee__4ztDj","paused":"NewsTicker_paused__3gFJz"};